import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import(/* webpackChunkName: "home" */ './views/Home.vue')
const UnifiedRoulette = () => import(/* webpackChunkName: "roulette" */ './views/UnifiedRoulette.vue')
const BuildLab = () => import(/* webpackChunkName: "build-lab" */ './views/BuildLab.vue')
const Intelligence = () => import(/* webpackChunkName: "intelligence" */ './views/Intelligence.vue')
const NotFoundComponent = () => import(/* webpackChunkName: "not-found" */ './views/NotFoundComponent.vue')

Vue.use(Router)

const confParams = route => ({
  color: route.query.color === '1',
  sids: route.query.sids ? route.query.sids.split(',') : [],
  kids: route.query.kids ? route.query.kids.split(',') : [],
  lang: route.query.lang ? route.query.lang.charAt(0).toUpperCase() + route.query.lang.toLowerCase().slice(1) : 'En',
  perksKHD: require('../public/sprites/kill-hd.json'),
  perksKMD: require('../public/sprites/kill-md.json'),
  perksSHD: require('../public/sprites/surv-hd.json'),
  perksSMD: require('../public/sprites/surv-md.json')
})

function redirectWithSide (name, side) {
  return route => ({ name, query: Object.assign({}, route.query, { side }) })
}

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    { path: '/', name: 'home', component: Home, props: confParams },
    { path: '/roulette', name: 'roulette', component: UnifiedRoulette, props: confParams },
    { path: '/build-lab', name: 'buildLab', component: BuildLab, props: confParams },
    { path: '/intelligence', name: 'intelligence', component: Intelligence, props: confParams },
    { path: '/survivor', redirect: redirectWithSide('roulette', 'survivor') },
    { path: '/killer', redirect: redirectWithSide('roulette', 'killer') },
    { path: '/survivor-best-build', redirect: redirectWithSide('buildLab', 'survivor') },
    { path: '*', component: NotFoundComponent }
  ]
})
